import { render } from "./GroupBill.vue?vue&type=template&id=2d320f9e&ts=true"
import script from "./GroupBill.vue?vue&type=script&lang=tsx"
export * from "./GroupBill.vue?vue&type=script&lang=tsx"

import "./GroupBill.vue?vue&type=style&index=0&id=2d320f9e&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__